import type {
  L2CChainSnapshot,
  L2CComparisonPreset,
  L2CPeriodGrain,
} from '../../../types/leadToCash';

export function buildL2CSurfaceContext(params: {
  snapshot: L2CChainSnapshot;
  grain: L2CPeriodGrain;
  preset: L2CComparisonPreset;
  selectedStageId: string | null;
}): Record<string, unknown> {
  const { snapshot, grain, preset, selectedStageId } = params;

  return {
    type: 'lead_to_cash',
    grain,
    preset,
    comparison_label: snapshot.comparison_label,
    comparison_mode: snapshot.comparison_mode,
    current_period: snapshot.current_period ?? snapshot.current_week ?? null,
    prior_period: snapshot.prior_period ?? snapshot.prior_week ?? null,
    selected_stage_id: selectedStageId,
    chain_summary: snapshot.chain_summary ?? null,
    period_in_progress: snapshot.period_in_progress ?? false,
    cohort_immature: snapshot.cohort_immature ?? false,
    partial_data: snapshot.partial_data ?? false,
    partial_message: snapshot.partial_message ?? null,
    computed_at: snapshot.computed_at ?? null,
    from_cache: snapshot.from_cache ?? false,
    capacity: snapshot.capacity ?? null,
    stages: snapshot.stages.map((stage) => ({
      id: stage.id,
      name: stage.name,
      order: stage.order,
      status: stage.status,
      data_unavailable: stage.data_unavailable,
      headline_metrics: stage.headline_metrics,
      supporting_metrics: stage.supporting_metrics ?? [],
      panel: stage.panel
        ? {
            what_happened: stage.panel.what_happened,
            why: stage.panel.why,
            suggestion: stage.panel.suggestion,
            movers: stage.panel.movers,
            breakdown_unavailable: stage.panel.breakdown_unavailable,
          }
        : null,
    })),
  };
}
